import { inject } from 'vue';

export const AMPLITUDE_ENGAGEMENT_PROVIDE_KEY = 'amplitudeEngagement';

export default function useAmplitudeEngagement() {
  const amplitudeEngagement = inject(AMPLITUDE_ENGAGEMENT_PROVIDE_KEY);

  if (!amplitudeEngagement) {
    throw new Error(
      'Amplitude Engagement was not provided in a parent component. Ensure that an AmplitudeEngagementService instance is made available via provide() in the App.',
    );
  }

  return amplitudeEngagement;
}
